





























import { Component, Vue, Prop } from 'vue-property-decorator'
import OzDrawerStatic from 'library/v4/components/OzDrawerStatic.vue'
import OzDrawerDraggable from 'library/v4/components/OzDrawerDraggable.vue'
import OzCenterModal from 'library/v4/components/OzCenterModal.vue'
/**
 * Screen size aware drawer modal that renders OzDrawer on phone and OzCenterModal on desktop. Used in Content picker.
 */
@Component({ components: { OzDrawerStatic, OzDrawerDraggable, OzCenterModal } })
export default class OzScreenSizeAwareCenterModal extends Vue {
  @Prop({ default: false }) isPhone!: boolean
  @Prop({ default: false }) isDraggableDrawer!: boolean
}
